export const APPROVAL_PAGE_WIDTH = 1500;
export const APPROVAL_PAGE_SECTION_GAP = 16;
export const APPROVAL_PAGE_BOTTOM_PADDING = 40;
export const APPROVAL_FILTERS_SECTION_ID = "APPROVE_REJECT_FILTERS";
